import SetPagination from "../../pagination/SetPagination";
import EntradasCardHorizontal from "./EntradasCardHorizontal";

function EntradasList({
  entradas,
  get_entrada_list_page,
  count,
  refreshData,
  user
}) {
  return (
    <div className="overflow-hidden">
      <div className="relative overflow-x-auto">
        <table className="table text-gray-500">
          <thead className="text-xs text-gray-700 uppercase">
            <tr>
              <th scope="col" className="p-2 dark:text-white"></th>
              <th scope="col" className="p-2 dark:text-white">Fecha</th>
              <th scope="col" className="p-2 dark:text-white">Remision</th>
              <th scope="col" className="p-2 dark:text-white">Descripción</th>
              <th scope="col" className="p-2 dark:text-white">Producto/Cantidad</th>
              <th scope="col" className="p-2 dark:text-white">Planta/Proveedor</th>
              <th scope="col" className="p-2 dark:text-white">Acciones</th>
            </tr>
          </thead>
          <tbody>

            {entradas && entradas.length > 0 ? (
              entradas.map((entrada, index) => (
                <EntradasCardHorizontal
                  data={entrada}
                  key={index}
                  index={index}
                  refreshData={refreshData}
                  user={user}
                />
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center p-4">
                  No hay registros disponibles.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <SetPagination
        list_page={get_entrada_list_page}
        list={entradas}
        count={count}
        type={"medium"}
      />
    </div>
  );
}
export default EntradasList;
